import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {ContentBlock} from 'components/UIKit';
import {mailToSupport} from 'utilities/urls';

import styles from './Support.scss';
import * as locales from './locales';

export interface SupportProps {}

function SupportComponent({i18n}: SupportProps & WithI18nProps) {
  return (
    <ContentBlock
      heading={i18n.translate('heading')}
      subhead={i18n.translate('subhead', {
        supportLink: <a href={mailToSupport}>{i18n.translate('supportLink')}</a>,
      })}
      cta={i18n.translate('cta')}
      url={mailToSupport}
      className={styles.support}
    />
  );
}

export const Support = withI18n({
  id: 'Support',
  fallback: locales.en,
})(SupportComponent);
